import $ from 'jquery'
import Dust from './Dust'
import Timer from './Timer'

$(document).ready(main)

function main () {
  const DUST = new Dust()
  const timer = new Timer()
  let frame = 0
  const fpsTimer = new Timer()

  $('#fps').html(0 + 'fps')
  $('#paused').hide()
  $('#limitReached').hide()
  $('#selectionBox').hide()

  // $('#brushSize').noUiSlider({
  //     range: [1, 60],
  //     start: 10,
  //     connect: "lower",
  //     handles: 1
  // });

  $('#canvainer').mousedown(function (e) {
    e.preventDefault()
    e.stopPropagation()
    $(document).unbind('mouseup')

    const offset = $('canvas').offset()

    const type = $('input[name=dustType]:checked', '#menu').val()
    // const brushType = $('input[name=brushType]:checked', '#menu2').val()
    const brushType = 'circle'
    const infect = $('input[name=infectant]:checked', '#menu').val()
    const brushGirth = parseInt($('#brushSize').val())

    switch (e.which) {
      case 1:
        if (DUST.dustCount >= DUST.MAX_DUST && type !== 'eraser') {
          $('#limitReached').show()
        } else {
          let x = Math.round(e.pageX - offset.left)
          let y = Math.round(e.pageY - offset.top)

          switch (brushType) {
            case 'circle':
              DUST.spawnCircle(x, y, type, brushGirth, infect)
              break
            case 'square':
              if (type !== 'eraser') { DUST.spawnRect(x - (brushGirth / 2), y - (brushGirth / 2), brushGirth, brushGirth, type, infect) } else { DUST.destroyRect(x - (brushGirth / 2), y - (brushGirth / 2), brushGirth, brushGirth) }
              break
            case 'boxfill':
              x = Math.round(e.pageX)
              y = Math.round(e.pageY)

              $('#selectionBox').show()
              $('#selectionBox').css({
                top: x,
                left: y,
                width: 0,
                height: 0
              })
              break
          }

          $('#canvainer').mousemove(function (e) {
            if (DUST.dustCount >= DUST.MAX_DUST && type !== 'eraser') {
              $('#limitReached').show()
            } else {
              let newX = Math.round(e.pageX - offset.left)
              let newY = Math.round(e.pageY - offset.top)
              let width = 0
              let height = 0

              switch (brushType) {
                case 'circle':
                  DUST.spawnCircle(newX, newY, type, brushGirth, infect)
                  break
                case 'square':
                  if (type !== 'eraser') { DUST.spawnRect(newX - (brushGirth / 2), newY - (brushGirth / 2), brushGirth, brushGirth, type, infect) } else { DUST.destroyRect(newX - (brushGirth / 2), newY - (brushGirth / 2), brushGirth, brushGirth) }
                  break
                case 'boxfill':
                  newX = Math.round(e.pageX)
                  newY = Math.round(e.pageY)

                  width = Math.abs(newX - x)
                  height = Math.abs(newY - y)

                  newX = (newX < x) ? (x - width) : x
                  newY = (newY < y) ? (y - height) : y

                  $('#selectionBox').css({
                    width,
                    height,
                    top: newY,
                    left: newX
                  })
                  break
              }
            }
          })
        }

        $(document).mouseup(function (e) {
          $('#canvainer').unbind('mousemove')
          $('#limitReached').hide()

          if (brushType === 'boxfill') {
            const $sb = $('#selectionBox')

            const x = Math.round($sb.position().left - $('canvas').position().left)
            const y = Math.round($sb.position().top - $('canvas').position().top)

            if (type !== 'eraser') { DUST.spawnRect(x, y, $sb.width(), $sb.height(), type, infect) } else { DUST.destroyRect(x, y, $sb.width(), $sb.height()) }

            $sb.hide()
          }
        })

        break
    }
  })

  $(document).keydown(function (e) {
    switch (e.which) {
      // Space
      case 32:
        if (DUST.paused) {
          $('#paused').hide()
          DUST.paused = false
        } else {
          $('#paused').show()
          DUST.paused = true
        }
        break
        // R
      case 82:
        for (let x = 0; x < DUST.grid.length; x++) {
          for (let y = 0; y < DUST.grid[x].length; y++) {
            DUST.grid[x][y] = 0
          }
        }
        DUST.dustCount = 0
        break
    }
  })

  $('#saveButton').click(function () {
    const name = $('input[name=levelName]', '#saveMenu').val()

    DUST.saveLevel(name)

    $('#saveButton').blur()
  })

  $('#loadButton').click(function () {
    const name = $('input[name=levelName]', '#saveMenu').val()

    DUST.loadLevel(name)
    DUST.getLevelThumb(name)

    $('#loadButton').blur()
  })

  function tick () {
    window.requestAnimationFrame(tick)

    frame++
    if (fpsTimer.getTime() > 1000) {
      $('#fps').html(frame + 'fps')
      fpsTimer.reset()
      frame = 0
    }

    if (!DUST.paused) DUST.update(timer.getTime() / 1000)

    DUST.draw()

    timer.reset()
  }

  tick()
}
